import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'qualifications_groups',
  inputShow: gql`
    query qualificationsGroups($input: QualificationsGroupQueryInput) {
      qualificationsGroups(input: $input) {
        id
        name
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Qualifications',
    label: 'Qualifications Groups',
  },
};
